export const NOTIFICATION_TIMEOUT_IN_SEC = 1000;
